import { Mic, Pencil } from 'lucide-react';
import soundEffects from '../../utils/soundEffects';

/**
 * Entry Mode Toggle Component
 * Toggles between Voice and Manual entry modes
 * (Scanner is accessed separately from within the modes)
 */
const EntryModeToggle = ({ 
  entryMode, 
  onModeChange,
  disabled = false 
}) => {
  const handleModeChange = (mode) => {
    soundEffects.playSwish();
    onModeChange(mode);
  };

  return (
    <div className="flex justify-center items-center gap-8 pb-4 border-b border-[var(--ps-border)]">
      <button
        onClick={() => handleModeChange('voice')}
        disabled={disabled}
        className={`flex items-center gap-2 transition-all ${
          entryMode === 'voice'
            ? 'text-[var(--ps-primary)] scale-105'
            : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
        }`}
        data-testid="voice-tab-btn"
      >
        <Mic className={`w-5 h-5 ${entryMode === 'voice' ? 'text-[var(--ps-primary)]' : ''}`} />
        <span className="text-lg font-bold">Voice</span>
      </button>
      <span className="text-[var(--ps-text-muted)]">|</span>
      <button
        onClick={() => handleModeChange('manual')}
        disabled={disabled}
        className={`flex items-center gap-2 transition-all ${
          entryMode === 'manual'
            ? 'text-[var(--ps-warning)] scale-105'
            : 'text-[var(--ps-text-muted)] hover:text-[var(--ps-text-secondary)]'
        }`}
        data-testid="manual-tab-btn"
      >
        <Pencil className={`w-5 h-5 ${entryMode === 'manual' ? 'text-[var(--ps-warning)]' : ''}`} />
        <span className="text-lg font-bold">Manual</span>
      </button>
    </div>
  );
};

export default EntryModeToggle;
